<template>
  <footer class="footer tw:flex tw:flex-wrap">
    <div class="tw:flex tw:w-full tw:justify-between tw:items-end">
      <RouterLink
        to="/"
        class="tw:flex tw:items-center tw:space-x-3 tw:rtl:space-x-reverse tw:no-underline tw:px-2"
        aria-label="Home"
      >
        <img :src="footerLogo" class="footer-image" alt="Allocore">
      </RouterLink>
      <div id="footer-copyright" class="tw:shrink-0 tw:font-semibold tw:text-white tw:text-sm">
        Copyright © {{ currentYear }} {{ organizationName }}. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { useTheme } from '@composables/useTheme';

  const { footerLogo, organizationName } = useTheme();
  const currentYear = new Date().getFullYear();
</script>

<style scoped>
  .footer {
    max-height: unset;
    padding: 1rem;
    background: linear-gradient(
      90deg,
      var(--footer-gradient-start, #0b1023) 0%,
      var(--footer-gradient-end, #104c87) 100.04%
    );
  }

  .footer-image {
    display: block;
    max-width: 40px;
    max-height: 40px;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
</style>
